import { MessagesView } from '../../components/messages';
import type { MessagingApi } from '../../state/useMessaging';

export interface MessagesViewsProps {
  view: string;
  /** The messaging slice AppShell owns (shared with the header's unread badge). */
  messaging: MessagingApi;
  effectivePlayerDB: any;
  clubInfo: any;
  goHome: () => void;
}

// View-group for the club's «Meldinger» (`view === 'messages'`). The slice is
// owned by AppShell so the header icon and this view read the same state.
export function MessagesViews({
  view,
  messaging,
  effectivePlayerDB,
  clubInfo,
  goHome,
}: MessagesViewsProps) {
  if (view !== 'messages') return null;
  return (
    <MessagesView
      messaging={messaging}
      effectivePlayerDB={effectivePlayerDB || []}
      clubInfo={clubInfo}
      onBack={goHome}
    />
  );
}
